import gql from "graphql-tag";

export const MY_NEWS_GET_ADMIN_LIST = gql`
  query getMyNewsAdminList($page: Int!, $pageSize: Int!) {
    getMyNewsAdminList(page: $page, pageSize: $pageSize) {
      page
      pageSize
      total
      totalPages
      rows {
        _id
        title
        description
        content
        priority
        createdAt
        createdBy
        publishedAt
        read
        editorEmployeeCode
        editorName
        validTo
      }
    }
  }
`;
